// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__JWeYf","overflowing":"ReadFullNote_overflowing__MLD-U"};